module.exports = __webpack_public_path__ + "img/default-avatar.2f3adab2.png";